'use client'

import React, { ReactElement, ReactNode, useState } from 'react'

import { ModelNewWithHeading } from '@/components/common/ModalNew'

export function HotelDetailModal(props: {
  text: ReactNode
  modalTitle: string
  modalContent: string
}): ReactElement | null {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  function closeModal() {
    setIsOpen(false)
  }

  return (
    <>
      <span
        className="cursor-help font-normal underline decoration-[rgba(41,37,36,0.70)] decoration-dashed underline-offset-[6px]"
        onClick={() => setIsOpen(true)}
      >
        {props.text}
      </span>
      {isOpen && (
        <ModelNewWithHeading
          close={closeModal}
          isOpen={isOpen}
          title={props.modalTitle}
          content={props.modalContent}
          narrow={true}
        />
      )}
    </>
  )
}
